import ColumnWidget from '@components/Widgets/ColumnWidget/ColumnWidget.vue'
import ImageColumnWidget
  from '@components/Widgets/ImageColumnWidget/ImageColumnWidget.vue'
import TwoColumnWidget
  from '@components/Widgets/TwoColumnWidget/TwoColumnWidget.vue'
import FortuneWheelWidget
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelWidget.vue'
import StickyBarWidget
  from '@components/Widgets/StickyBarWidget/StickyBarWidget.vue'
import WidgetItems from '@components/menues/WidgetItems/WidgetItems.vue'
import WidgetGalleryModal
  from '@components/modals/WidgetGalleryModal/WidgetGalleryModal.vue'
import Watermark from '@components/Widgets/_global/Watermark/Watermark.vue'
import UndoRedo from '@components/UndoRedo/UndoRedo.vue'
import { mapActions } from 'vuex'
import { type } from '@meta/widget/options'

export default {
  name: 'Canvas',
  components: {
    'column-widget-component': ColumnWidget,
    'image-column-widget-component': ImageColumnWidget,
    'two-column-widget-component': TwoColumnWidget,
    'fortune-wheel-widget-component': FortuneWheelWidget,
    'sticky-bar-widget-component': StickyBarWidget,
    'widget-items-menu-component': WidgetItems,
    'widget-gallery-modal-component': WidgetGalleryModal,
    'watermark': Watermark,
    UndoRedo,
  },
  computed: {
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
    targetedWidgetItem() {
      return this.widgetItems[this.targetWidgetID] || null
    },
    widgetComponent() {
      if (!this.targetedWidgetItem) return null

      const typeComponentMap = {
        [type.COLUMN]: 'column-widget-component',
        [type.IMAGE_COLUMN]: 'image-column-widget-component',
        [type.TWO_COLUMN]: 'two-column-widget-component',
        [type.FORTUNE_WHEEL]: 'fortune-wheel-widget-component',
        [type.STICKY_BAR]: 'sticky-bar-widget-component',
      }

      return typeComponentMap[this.targetedWidgetItem.type] || null
    },
    widgetItems() {
      return this.$store.getters['campaign/widget/getWidgetItems']
    },
    widgetItemsList() {
      return this.$store.getters['campaign/widget/getWidgetItemsList']
    },
  },
  data() {
    return {
      isWidgetGalleryModalOpen: false,
    }
  },
  methods: {
    ...mapActions('campaign/widget', ['updateWidgetDetails']),
    ...mapActions('campaign/contentItem', ['clearTargetContentItem']),
    toggleWidgetGalleryModal() {
      this.isWidgetGalleryModalOpen = !this.isWidgetGalleryModalOpen
    },
    triggerWidgetNameChange(id) {
      this.$msgbox
        .prompt('', 'Rename this widget', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputValue: this.widgetItems[id].name,
        })
        .then(({ value }) => {
          if (value !== this.widgetItems[id].name) {
            const newValue = value.trim(' ')
            const path = ['name']

            this.updateWidgetDetails({ id, path, value: newValue })
            this.$message({
              type: 'success',
              message: 'Widget successfully renamed to \'' + newValue + '\'',
            })
          }
        })
        .catch(() => {})
    },
  },
}
